var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33323 1V3.66666M3.99997 1V3.66666M1.33325 6.33334H11.9999M1.33325 3.66667C1.33325 3.31305 1.47373 2.97391 1.72378 2.72386C1.97382 2.47382 2.31296 2.33334 2.66658 2.33334H10.6666C11.0202 2.33334 11.3593 2.47382 11.6094 2.72386C11.8594 2.97391 11.9999 3.31305 11.9999 3.66667V11.6667C11.9999 12.0203 11.8594 12.3594 11.6094 12.6095C11.3593 12.8595 11.0202 13 10.6666 13H2.66658C2.31296 13 1.97382 12.8595 1.72378 12.6095C1.47373 12.3594 1.33325 12.0203 1.33325 11.6667V3.66667ZM3.99997 8.99999H5.3333V10.3333H3.99997V8.99999Z",
    stroke: "#222529",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarInput);
export default __webpack_public_path__ + "static/media/IconCalendarInput.80cce30415481091d8eec53717955796.svg";
export { ForwardRef as ReactComponent };